export enum DocumentType {
    NZ_DRIVERS_LICENCE = "nz_drivers_licence",
    NZ_PASSPORT = "nz_passport",
    OTHER = "other",
    NZ_HIGH_SCHOOL_ID = "nz_high_school_id",
    NZ_TERTIARY_STUDENT_ID = "nz_tertiary_student_id",
    MY_MAHI_STUDENT_ID = "my_mahi_student_id",
    NO_ID = "no_id"
}

export const documentTypeToLabel = (documentType: DocumentType): string => {
    switch (documentType.toLowerCase()) {
        case DocumentType.NZ_DRIVERS_LICENCE:
            return "New Zealand drivers licence"
        case DocumentType.NZ_HIGH_SCHOOL_ID:
            return "High school ID"
        case DocumentType.NZ_TERTIARY_STUDENT_ID:
            return "Tertiary student ID"
        case DocumentType.NO_ID:
            return "no ID"
        case DocumentType.MY_MAHI_STUDENT_ID:
            return "MyMahi Student ID"
        case DocumentType.NZ_PASSPORT:
        case DocumentType.OTHER:
            return "Passport"
        default:
            return ""
    }
}

export const stringToDocumentType = (value: string): DocumentType => {
    switch (value.toLowerCase()) {
        case DocumentType.NZ_DRIVERS_LICENCE:
            return DocumentType.NZ_DRIVERS_LICENCE
        case DocumentType.NZ_PASSPORT:
            return DocumentType.NZ_PASSPORT
        case DocumentType.NZ_HIGH_SCHOOL_ID:
            return DocumentType.NZ_HIGH_SCHOOL_ID
        case DocumentType.NZ_TERTIARY_STUDENT_ID:
            return DocumentType.NZ_TERTIARY_STUDENT_ID
        case DocumentType.NO_ID:
            return DocumentType.NO_ID
        case DocumentType.MY_MAHI_STUDENT_ID:
            return DocumentType.MY_MAHI_STUDENT_ID
        case DocumentType.OTHER:
        default:
            return DocumentType.OTHER
    }
}